var _g, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemgoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 50,
    viewBox: "0 0 209 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2994_950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5187 10.5492C13.8056 11.1548 15.5206 12.7945 16.2173 13.5387C10.219 11.1739 8.68489 15.0577 8.68489 15.093C11.9618 15.8329 12.9132 19.4975 13.0542 19.9556C13.1951 20.4136 14.6154 25.5595 14.6632 25.5117C17.3425 32.4011 23.7321 34.1559 23.638 33.9676C16.9235 25.3809 19.4196 16.7705 21.5069 13.5387C25.7386 4.22373 37.6034 0.631664 43.0068 0C40.3588 19.23 26.2986 20.9015 26.3617 20.9015C38.2149 14.3767 40.6108 2.77416 40.5854 2.71111C26.2403 6.14098 21.8893 15.8253 21.5069 20.2388C20.7503 28.0568 26.1938 34.8603 26.1938 34.8911C28.5638 35.7221 40.5854 35.1147 40.5854 35.1336C34.3778 36.9694 27.5078 36.572 27.5078 36.5909C27.5645 36.9505 32.0121 41.398 32.031 41.3601C30.6835 40.8908 27.1293 37.7453 25.5206 36.2313C20.0094 35.7619 16.1461 32.238 14.9033 30.5347C12.9956 28.7784 11.5724 23.3808 11.0992 20.9015C11.0109 20.2328 10.4406 18.5775 8.86602 17.3057C7.29141 16.0339 5.08089 15.6024 4.17246 15.5456C5.9704 14.6561 5.66759 14.5804 6.85991 13.5387C7.48067 12.5085 8.78401 11.2805 9.35809 10.7952C9.87539 10.4609 11.2317 9.94358 12.5187 10.5492Z",
    fill: "#15585D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4725 20.3716C25.8244 20.3023 35.7423 16.6046 40.5986 2.3681C27.2241 5.59725 21.4725 15.4049 21.4725 20.3716Z",
    fill: "#9F7F2C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0377 36.1798L87.235 38.8765C86.0365 40.0084 82.6407 41.9726 78.6457 40.7741C74.6507 39.5756 73.5523 36.879 73.2525 34.2822C73.186 31.752 74.7108 26.2522 80.943 26.4919C87.5349 26.7454 88.267 32.1182 88.1338 34.5818V35.0812H77.8466C78.3793 36.6126 80.5633 38.9763 85.0377 36.1798ZM83.939 32.4844H77.8466C77.8466 32.4844 78.346 30.0874 80.9428 29.9875C83.0202 29.9076 83.9723 31.6188 83.939 32.4844Z",
    fill: "#15585D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.962 40.8479V32.1588C163.028 30.4276 161.623 26.7455 157.069 26.6656C154.073 26.613 152.575 26.9652 150.377 28.3635C150.857 29.4022 151.643 30.8604 151.975 31.4596C153.274 30.7272 156.29 29.562 157.968 30.7605C158.513 31.3958 158.645 31.9487 158.739 32.3441C158.749 32.3838 158.758 32.4219 158.767 32.4584C156.137 31.8591 150.717 31.6794 150.078 35.7543C149.379 38.6507 151.376 40.3486 152.575 40.8479C153.773 41.3473 157.768 41.4472 158.967 39.3498V40.8479H162.962ZM155.172 37.9515C158.288 38.7505 158.867 36.3535 158.767 35.0551C155.172 34.5757 154.206 35.3881 154.173 35.8541C154.04 36.2536 154.053 37.2324 155.172 37.9515Z",
    fill: "#15585D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.665 41.1484H132.371V27.3656H136.665V28.664C137.944 26.9861 140.061 27.0993 140.96 27.3656C140.927 28.5974 140.88 31.061 140.96 31.061C137.684 30.5017 136.732 32.7589 136.665 33.9574V41.1484Z",
    fill: "#15585D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5705 41.1484H46.2549V19H50.6846L58.658 31.9937L66.6314 19H71.0611V41.1484H65.7455L65.4502 29.9265L60.1346 38.4906H57.1814L51.5705 29.9265V41.1484Z",
    fill: "#15585D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.671 41.1484C205.698 41.1484 208.962 37.8394 208.962 33.7576C208.962 29.6758 205.698 26.3668 201.671 26.3668C197.645 26.3668 194.38 29.6758 194.38 33.7576C194.38 37.8394 197.645 41.1484 201.671 41.1484ZM201.671 37.565C203.746 37.565 205.427 35.8604 205.427 33.7576C205.427 31.6549 203.746 29.9502 201.671 29.9502C199.597 29.9502 197.915 31.6549 197.915 33.7576C197.915 35.8604 199.597 37.565 201.671 37.565Z",
    fill: "#9F7F2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.191 23.0185L188.805 26.127L188.241 25.5618C182.372 21.2664 178.647 25.2792 177.518 27.8225C175.543 36.3003 182.88 36.5829 185.137 36.5829C186.943 36.5829 187.206 35.4525 187.112 34.8873V29.8007H191.627V37.7132C191.175 39.5218 188.429 40.5391 187.112 40.8217C177.406 42.6303 173.098 36.4887 172.157 33.1918C171.499 29.6123 171.932 21.9446 178.929 19.91C185.927 17.8753 190.686 21.1345 192.191 23.0185Z",
    fill: "#9F7F2C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 165.153,
    y: 21.9723,
    width: 4.59428,
    height: 19.1761,
    fill: "#15585D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5317 41.1484H90.3369V27.3656H94.5317V28.5641C97.8875 25.448 101.456 27.7318 102.821 29.2632C103.54 28.2245 104.719 27.5653 105.218 27.3656C111.93 25.8475 113.475 30.5283 113.408 33.0585V41.1484H109.014V33.3581C109.08 32.4925 108.694 30.7614 106.617 30.7614C104.539 30.7614 104.02 32.4925 104.02 33.3581V41.1484H99.8251V33.3581C99.8251 32.5258 99.2858 30.8413 97.1285 30.7614C94.9711 30.6814 94.4984 32.4592 94.5317 33.3581V41.1484Z",
    fill: "#15585D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.891 41.1484C126.917 41.1484 130.181 37.8394 130.181 33.7576C130.181 29.6758 126.917 26.3668 122.891 26.3668C118.864 26.3668 115.6 29.6758 115.6 33.7576C115.6 37.8394 118.864 41.1484 122.891 41.1484ZM122.891 37.565C124.965 37.565 126.646 35.8604 126.646 33.7576C126.646 31.6549 124.965 29.9502 122.891 29.9502C120.816 29.9502 119.135 31.6549 119.135 33.7576C119.135 35.8604 120.816 37.565 122.891 37.565Z",
    fill: "#15585D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.744 29.4191L143.149 29.3656V41.1484H147.744V29.4191Z",
    fill: "#15585D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143.149,
    y: 23.0928,
    width: 4.59424,
    height: 4.60702,
    fill: "#15585D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2994_950",
    x: 0.172363,
    y: 0,
    width: 46.8345,
    height: 49.3604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2994_950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2994_950",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemgoLogo);
export default __webpack_public_path__ + "static/media/memgo-logo.f7fce424cc1c76b20bc46081a0b7c679.svg";
export { ForwardRef as ReactComponent };